"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _reactQuery = require("react-query");
var _core = require("@folio/stripes/core");
var _utils = require("../../utils");
const useTypedownData = (path, callPath) => {
  const ky = (0, _core.useOkapiKy)();
  const queryKey = (0, _utils.typedownQueryKey)(path);
  if (callPath) {
    queryKey.push(callPath);
  }
  const {
    data,
    isLoading
  } = (0, _reactQuery.useQuery)(
  // Ensure when multiple apps are using this function that each one gets memoized individually
  queryKey, () => ky(callPath).json());

  // Smooth out transitions while data changes by only displaying once call has been loaded.
  const [contentData, setContentData] = (0, _react.useState)();
  (0, _react.useEffect)(() => {
    if (!isLoading) {
      setContentData(data);
    }
  }, [data, isLoading]);
  return contentData;
};
var _default = exports.default = useTypedownData;